import React from 'react';
import { motion } from 'framer-motion';
export function ResourcesSection() {
  return <section id="resurse" className="bg-brand-beige section-padding relative overflow-hidden" data-id="element-297">
      {/* Decorative Background Elements */}
      <svg className="absolute top-0 left-0 w-64 h-64 text-brand-gold/10 -z-10 -translate-x-1/2 -translate-y-1/2" viewBox="0 0 100 100" data-id="element-298">
        <defs data-id="element-299">
          <pattern id="dots-resources" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse" data-id="element-300">
            <circle cx="2" cy="2" r="2" fill="currentColor" data-id="element-301" />
          </pattern>
        </defs>
        <rect x="0" y="0" width="100" height="100" fill="url(#dots-resources)" data-id="element-302" />
      </svg>

      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-brand-coral/5 rounded-full blur-3xl translate-y-1/3 translate-x-1/3 pointer-events-none" data-id="element-303"></div>

      <div className="container-custom" data-id="element-304">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-305">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="flex flex-col items-start gap-6" data-id="element-306">
            <div className="badge bg-brand-gold/20 text-brand-navy" data-id="element-307">
              RESURSE GRATUITE
            </div>

            <h2 className="text-[32px] md:text-[42px] leading-[1.2]" data-id="element-308">
              Începe de aici, cu resurse practice de la mine
            </h2>

            <p className="text-[16px] md:text-[18px] text-brand-text" data-id="element-309">
              Primești acces la un mini-curs gratuit și la materiale practice
              (ghiduri de dezvoltare, idei de joc, exerciții simple) ca să poți
              începe să lucrezi cu copilul tău chiar de acum, acasă.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 mt-4 w-full sm:w-auto" data-id="element-310">
              <a href="#mini-curs" className="btn-primary w-full sm:w-auto" data-id="element-311">
                Descarcă Ghidul Gratuit
              </a>
              <a href="/resursegratuite" className="btn-secondary w-full sm:w-auto" data-id="element-312">
                Vezi toate resursele gratuite
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="relative" data-id="element-313">
            {/* Decorative Blob Behind Image */}
            <svg className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] text-brand-gold/20 -z-10" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-314">
              <path fill="currentColor" d="M42.7,-73.4C55.9,-66.5,67.6,-55.4,76.5,-42.1C85.4,-28.8,91.5,-13.3,90.4,1.7C89.3,16.7,81.1,31.2,71.2,43.4C61.3,55.6,49.7,65.5,36.5,72.4C23.3,79.3,8.5,83.2,-6.1,82.8C-20.7,82.4,-35.1,77.7,-47.8,69.6C-60.5,61.5,-71.5,50.1,-78.6,36.4C-85.7,22.7,-88.9,6.7,-86.1,-8.5C-83.3,-23.7,-74.5,-38.1,-62.6,-49.2C-50.7,-60.3,-35.7,-68.1,-21.5,-72.6C-7.3,-77.1,6.1,-78.3,20.4,-76.8C34.7,-75.3,49.9,-71.1,42.7,-73.4Z" transform="translate(100 100)" data-id="element-315" />
            </svg>

            <div className="relative w-full aspect-[4/3] rounded-[24px] overflow-hidden shadow-card border-4 border-white transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-316">
              <img src="https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=600&q=80" alt="Resurse educaționale" className="w-full h-full object-cover" data-id="element-317" />
              <div className="absolute inset-0 bg-brand-navy/10 mix-blend-multiply" data-id="element-318"></div>
            </div>

            {/* Floating Element */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-[16px] shadow-card border border-brand-beige flex items-center gap-3 transform -rotate-3" data-id="element-319">
              <div className="w-10 h-10 rounded-full bg-brand-coral/20 flex items-center justify-center text-brand-coral font-bold text-xl" data-id="element-320">
                PDF
              </div>
              <div data-id="element-321">
                <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-322">
                  Ghid Practic
                </p>
                <p className="font-source text-[12px] text-brand-textSecondary" data-id="element-323">
                  Descărcare instantă
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}